document.addEventListener('DOMContentLoaded', () => {
  const marquees = document.querySelectorAll('.announcement-marquee');

  marquees.forEach((marquee) => {
    const track = marquee.querySelector('.announcement-marquee__track');
    if (!track) return;

    const original = track.children[0];
    if (!original) return;

    // Vänta på fonts (annars fel bredd)
    document.fonts.ready.then(() => {
      // Rensa gamla kloner
      track.querySelectorAll('[data-clone]').forEach((el) => el.remove());

      // 🔹 Klona tills vi täcker minst 2 viewport
      let totalWidth = track.scrollWidth;
      const targetWidth = window.innerWidth * 2;

      while (totalWidth < targetWidth) {
        const clone = original.cloneNode(true);
        clone.dataset.clone = 'true';
        track.appendChild(clone);
        totalWidth = track.scrollWidth;
      }

      // 🔹 Exakt pixelbredd för halva tracken
      const loopWidth = track.scrollWidth / 2;

      let x = 0;
      const speed = 0.35; // px per frame (justera här)

      function animate() {
        x -= speed;

        if (Math.abs(x) >= loopWidth) {
          x = 0; // reset exakt när första kopian är ute
        }

        track.style.transform = `translateX(${x}px)`;
        requestAnimationFrame(animate);
      }

      animate();
    });
  });
});
